import React from "react";
import TOCLevel from "./toc-level";
import { Isvg } from "../../components";
import AccessibleSearchResults from "../../../accessability/accessibleSearchResults";

const SearchResults = ({ chapters, checkTOCNodeLengths, goToPage, reset }) => {
  if (chapters === "" || chapters === null) {
    reset();
    return null;
  }

  if (chapters.length === 0) {
    return (
      <div id="toc-no-results">
        <ul className="level-container">
          <div id="toc-error-container">
            {Fraction.Brand.Graphics.watkins && (
              <Isvg id="laptop-no" src={"/img/prop_laptop_dust.svg"}>
                NS
              </Isvg>
            )}
            <div id="error-message-one">{i18n.t("reader.toc.nothing")}</div>
            <div id="error-message-two">{i18n.t("reader.toc.spelling")}</div>
          </div>
        </ul>
      </div>
    );
  }

  const navigate = (cfi, page, path, e) => {
    $(".active").removeClass("active");
    if (e.target.className === "title no-pages dotted") {
      $(e.target)
        .parent()
        .parent()
        .addClass("active");
    } else if ($(e.target).parent().className === "section") {
      $(e.target)
        .parent()
        .addClass("active");
    } else if (e.target.className === "") {
      $(e.target)
        .parent()
        .addClass("active");
    } else {
      $(e.target).addClass("active");
    }
    goToPage(cfi, page, path);
  };

  return (
    <div>
      <div
        key="ghost-level-toc"
        tabIndex="-1"
        className="toc-container"
        id="ghost-toc-container"
      />
      <div id="toc-container" className="toc-container">
        <AccessibleSearchResults total={chapters.length}/>
        <ul
          id="search-result-list"
          className="level-container"
          onScroll={checkTOCNodeLengths}
        >
          {chapters.map(chapter => (
            <TOCLevel
              activeKey={`toc_level_${chapter.cfi}`}
              goToPage={navigate}
              hasPages={false}
              info={chapter}
              key={chapter.cfi}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SearchResults;
